import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const DisputeResolution = ({ dispute, onSubmitResponse, onEscalate, onResolve }) => {
  const [response, setResponse] = useState('');
  const [resolution, setResolution] = useState('');

  const resolutionOptions = [
    { value: 'refund', label: 'Tam İade' },
    { value: 'partial', label: 'Kısmi İade' },
    { value: 'revision', label: 'Revizyon Talebi' },
    { value: 'mediation', label: 'Arabuluculuk' }
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case 'open':
        return 'bg-warning/10 text-warning';
      case 'in-review':
        return 'bg-primary/10 text-primary';
      case 'resolved':
        return 'bg-success/10 text-success';
      case 'escalated':
        return 'bg-error/10 text-error';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  return (
    <div className="space-y-6">
      <div className="bg-card border border-border rounded-lg p-6">
        <div className="flex items-start justify-between gap-4 mb-4">
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-2">
              <h3 className="text-lg font-semibold text-foreground">{dispute?.title}</h3>
              <div className={`flex items-center gap-1 px-2 py-1 rounded-md text-xs font-medium ${getStatusColor(dispute?.status)}`}>
                <Icon name="AlertCircle" size={12} />
                <span className="capitalize">{dispute?.status}</span>
              </div>
            </div>
            <p className="text-sm text-muted-foreground">Kampanya: {dispute?.campaignTitle}</p>
          </div>
          <div className="text-right">
            <p className="text-sm text-muted-foreground">Açılış Tarihi</p>
            <p className="text-sm font-medium text-foreground">{dispute?.openedDate}</p>
          </div>
        </div>

        <div className="bg-muted rounded-lg p-4 mb-4">
          <p className="text-sm font-medium text-foreground mb-2">Anlaşmazlık Detayları:</p>
          <p className="text-sm text-muted-foreground">{dispute?.description}</p>
        </div>

        <div className="grid grid-cols-2 gap-4 mb-4">
          <div>
            <p className="text-xs text-muted-foreground mb-1">Şikayetçi</p>
            <p className="text-sm font-medium text-foreground">{dispute?.complainant}</p>
          </div>
          <div>
            <p className="text-xs text-muted-foreground mb-1">Karşı Taraf</p>
            <p className="text-sm font-medium text-foreground">{dispute?.respondent}</p>
          </div>
          <div>
            <p className="text-xs text-muted-foreground mb-1">Anlaşmazlık Tutarı</p>
            <p className="text-sm font-medium text-foreground">{dispute?.amount}</p>
          </div>
          <div>
            <p className="text-xs text-muted-foreground mb-1">Kategori</p>
            <p className="text-sm font-medium text-foreground">{dispute?.category}</p>
          </div>
        </div>
      </div>
      <div className="bg-card border border-border rounded-lg p-6">
        <h4 className="font-semibold text-foreground mb-4">İletişim Geçmişi</h4>
        <div className="space-y-4 mb-4">
          {dispute?.communications?.map((comm) => (
            <div key={comm?.id} className="border-l-2 border-primary pl-4">
              <div className="flex items-center justify-between mb-1">
                <p className="text-sm font-medium text-foreground">{comm?.sender}</p>
                <p className="text-xs text-muted-foreground">{comm?.date}</p>
              </div>
              <p className="text-sm text-muted-foreground">{comm?.message}</p>
            </div>
          ))}
        </div>

        {dispute?.status !== 'resolved' && (
          <div className="space-y-4">
            <Input
              label="Yanıtınız"
              type="text"
              placeholder="Mesajınızı yazın..."
              value={response}
              onChange={(e) => setResponse(e?.target?.value)}
            />
            <Button
              variant="default"
              iconName="Send"
              iconPosition="left"
              onClick={() => {
                onSubmitResponse(response);
                setResponse('');
              }}
              disabled={!response?.trim()}
            >
              Yanıt Gönder
            </Button>
          </div>
        )}
      </div>
      {dispute?.status === 'open' && (
        <div className="bg-card border border-border rounded-lg p-6">
          <h4 className="font-semibold text-foreground mb-4">Çözüm Önerisi</h4>
          <div className="space-y-4">
            <Select
              label="Çözüm Türü"
              options={resolutionOptions}
              value={resolution}
              onChange={setResolution}
              placeholder="Bir çözüm seçin"
            />
            <div className="flex items-center gap-2">
              <Button
                variant="default"
                iconName="CheckCircle"
                iconPosition="left"
                onClick={() => onResolve(resolution)}
                disabled={!resolution}
              >
                Çözümü Onayla
              </Button>
              <Button
                variant="outline"
                iconName="AlertTriangle"
                iconPosition="left"
                onClick={onEscalate}
              >
                Yönetici Desteği İste
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DisputeResolution;